import React, {Component} from 'react';
import {connect} from 'react-redux';
import _ from 'lodash';
import {Card, Grid, Dropdown, Input, Button} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import {findUserAgency} from '../../../common/util/user';
import {dealerOrderStatus, dealerOrderTypes} from '../../../common/constants/lists';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {parseAgencies} from '../../../common/util/options';
import {paths} from '../../../common/dictionaries/urls';
import TrackingSchedule from '../trackingSchedule';
import Detail from './detail';
import './groupedManagement.scss';

class GroupedManagement extends Component {
  constructor(props) {
    super(props);
    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.handleClearClick = this.handleClearClick.bind(this);
    this.handleSearchClick = this.handleSearchClick.bind(this);
    this.handleExportClick = this.handleExportClick.bind(this);
    this.handleStatusChange = this.handleStatusChange.bind(this);
  }

  componentDidMount() {
    const {permissions} = this.props;

    if (!hasAccessPermission(permissions, resources.DealerOrdersGroupedManagement, scopes.See)) {
      this.props.navigateTo(paths.AccessDenied);
    }
    this.props.restoreOrdersGroupedManagement();
    this.props.getAllAgencies();
  }

  handleFilterChange(event, data) {
    this.props.editOrdersGroupedManagementFilter(data.id, data.value.toUpperCase());
  }

  handleStatusChange(event, data) {
    this.props.editOrdersGroupedManagementFilter(data.id, data.value);
  }

  handleSearchClick() {
    const {orderType, orderCode, user, agency, partCode, status, userAgency} = this.props;
    if (!orderCode && !partCode && !status) {
      this.props.addMessageBoxError(
        'El código de repuesto o el código de pedido son requeridos si desea realizar la búsqueda de todos los estados'
      );
      return false;
    }
    this.props.getDealersOrdersManagement({
      orderType,
      orderCode,
      user,
      partCode,
      status,
      agency,
      'userDealer': userAgency.dealerId,
      'dealer': userAgency.dealerId,
    });
  }

  handleExportClick() {
    const {orderType, orderCode, user, agency, partCode, status, userAgency} = this.props;
    if (!orderCode && !partCode && !status) {
      this.props.addMessageBoxError(
        'El código de repuesto o el código de pedido son requeridos si desea realizar la búsqueda de todos los estados'
      );
      return false;
    }
    this.props.downloadDealerOrderManagement({
      orderType,
      orderCode,
      user,
      partCode,
      status,
      agency,
      'userDealer': userAgency.dealerId,
      'dealer': userAgency.dealerId,
    });
  }

  handleClearClick() {
    this.props.restoreOrdersGroupedManagement();
  }

  blockFilter() {
    const {orderCode, partCode, status} = this.props;
    return !orderCode && !partCode && !status;
  }

  render() {
    const {
      userAgency, loadingAgencies, downloading, loading, agencies, agency, orderType, status, partCode, user, orderCode,
    } = this.props;

    if (_.isEmpty(userAgency)) {
      return (
        <Card raised fluid>
          <h2>Estimado usuario, su agencia no está habilitada en el sistema.</h2>
        </Card>
      );
    }

    return (
      <div className='dealer-orders-tracking'>
        <Card raised fluid className='tracking-header'>
          <Grid>
            <Grid.Row>
              <Grid.Column width='10' textAlign='left'>
                <h2>Pedidos Totales</h2>
                <div className='user-agency'>
                  {userAgency.dealerName} | {userAgency.description}
                </div>
              </Grid.Column>
              <Grid.Column width='6' textAlign='right'>
                <Button secondary disabled={loading} content='LIMPIAR' onClick={this.handleClearClick} />
                <Button
                  primary
                  disabled={loading || downloading}
                  content='EXPORTAR A EXCEL'
                  onClick={this.handleExportClick}
                />
                <Button primary disabled={loading} content='BUSCAR' onClick={this.handleSearchClick} />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row columns='4'>
              <Grid.Column textAlign='left'>
                <label htmlFor='orderType'>
                  <strong>Tipo de pedido</strong>
                </label>
                <Dropdown
                  fluid
                  selection
                  id='orderType'
                  placeholder='Tipo de pedido'
                  options={dealerOrderTypes}
                  value={orderType}
                  onChange={this.handleFilterChange}
                />
              </Grid.Column>
              <Grid.Column textAlign='left'>
                <label htmlFor='status'>
                  <strong>Estado</strong>
                </label>
                <Dropdown
                  fluid
                  selection
                  id='status'
                  placeholder='Estado'
                  options={dealerOrderStatus}
                  value={status}
                  onChange={this.handleStatusChange}
                />
              </Grid.Column>
              <Grid.Column textAlign='left'>
                <label htmlFor='partCode'>
                  <strong>Código parte</strong>
                </label>
                <Input
                  fluid
                  id='partCode'
                  placeholder='Código de parte'
                  maxLength='20'
                  value={partCode}
                  onChange={this.handleFilterChange}
                />
              </Grid.Column>
              <Grid.Column textAlign='left'>
                <label htmlFor='partCode'>
                  <strong>Número de pedido</strong>
                </label>
                <Input
                  fluid
                  id='orderCode'
                  placeholder='Número de Pedido'
                  maxLength='8'
                  value={orderCode}
                  onChange={this.handleFilterChange}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row columns='4'>
              <Grid.Column textAlign='left'>
                <label>
                  <strong>Agencia</strong>
                </label>
                <Dropdown
                  fluid
                  selection
                  id='agency'
                  disabled={loadingAgencies || this.blockFilter()}
                  options={parseAgencies(agencies, userAgency.dealerId)}
                  value={agency}
                  onChange={this.handleStatusChange}
                />
              </Grid.Column>
              <Grid.Column textAlign='left'>
                <label htmlFor='user'>
                  <strong>Usuario</strong>
                </label>
                <Input
                  fluid
                  id='user'
                  placeholder='Usuario'
                  maxLength='30'
                  disabled={this.blockFilter()}
                  value={user}
                  onChange={this.handleFilterChange}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Card>
        <Detail />
        <TrackingSchedule />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const {dealerId, dealerAgency} = state.session;
  const {agencies} = state.dealer;
  const userAgency = findUserAgency(agencies, dealerId, dealerAgency);

  return {
    'permissions': state.session.permissions,
    'userAgency': userAgency || {},
    'downloading': state.ordersGroupedManagement.downloading,
    'loading': state.ordersGroupedManagement.loading,
    'loadingAgencies': state.dealer.loadingAgencies,
    'agencies': state.dealer.agencies,
    'orderType': state.ordersGroupedManagement.orderType,
    'status': state.ordersGroupedManagement.status,
    'user': state.ordersGroupedManagement.user,
    'partCode': state.ordersGroupedManagement.partCode,
    'orderCode': state.ordersGroupedManagement.orderCode,
    'agency': state.ordersGroupedManagement.agency,
  };
};

const {
  getAllAgencies,
  restoreOrdersGroupedManagement,
  editOrdersGroupedManagementFilter,
  getDealersOrdersManagement,
  downloadDealerOrderManagement,
  addMessageBoxError,
  navigateTo,
} = Actions;

export default connect(mapStateToProps, {
  getAllAgencies,
  restoreOrdersGroupedManagement,
  editOrdersGroupedManagementFilter,
  getDealersOrdersManagement,
  downloadDealerOrderManagement,
  addMessageBoxError,
  navigateTo,
})(GroupedManagement);
